export default {
  BASE_URL: '',
  api: [
    {
      name: 'receiveDetail',
      desc: '获取送货单详情',
      method: 'GET',
      path: 'tm/order/receipt/supplier/tmb/signDel'
    },
    {
      name: 'receiveDetailV2',
      desc: '获取送货单详情',
      method: 'GET',
      path: 'tm/order/receipt/supplier/tmb/signDelV2'
    },
    {
      name: 'saveReceive',
      desc: '提交送货单',
      method: 'POST',
      path: 'tm/order/receipt/supplier/tmb/subSign'
    },
    {
      name: 'receipt',
      desc: '签收自建送货单',
      method: 'POST',
      path: 'tm/order/receipt/supplier/tmb/subSign/receipt'
    },
    {
      name: 'back',
      desc: '回退自建送货单',
      method: 'POST',
      path: 'tm/order/receipt/supplier/tmb/subSign/back'
    },
    {
      name: 'receiveLog',
      desc: '送货单日志',
      method: 'GET',
      path: 'tm/order/receipt/supplier/log'
    },
    {
      name: 'rollbackReason',
      desc: '获取回退原因',
      method: 'GET',
      path: 'tm/order/receipt/supplier/sign/rollbackReason'
    },
    {
      name: 'detailRemark',
      desc: '获取签收原因',
      method: 'GET',
      path: 'tm/order/receipt/supplier/sign/detailRemark'
    },
    {
      name: 'receiveDetailV5',
      desc: '获取送货单详情',
      method: 'GET',
      path: 'tm/order/receipt/detail'
    },
    {
      name: 'saveReceiveV5',
      desc: '提交送货单',
      method: 'POST',
      path: '/tm/order/receipt/save'
    },
    {
      name: 'saveThdV5',
      desc: '新增退货单',
      method: 'POST',
      path: '/tm/order/receipt/thd/save'
    },
    {
      name: 'receiptV5',
      desc: '送货单签收',
      method: 'POST',
      path: '/tm/order/receipt/receipt'
    },
    {
      name: 'thdReceiptV5',
      desc: '签收退货单',
      method: 'POST',
      path: '/tm/order/receipt/thd/receipt'
    },
    {
      name: 'batchReceiptV5',
      desc: '批量送货单签收',
      method: 'POST',
      path: '/tm/order/receipt/batchReceipt'
    },
    {
      name: 'backV5',
      desc: '回退送货单',
      method: 'POST',
      path: '/tm/order/receipt/back'
    },
    {
      name: 'cancelV5',
      desc: '取消送货单',
      method: 'POST',
      path: '/tm/order/receipt/cancel'
    },
    {
      name: 'logV5',
      desc: '取消送货单',
      method: 'GET',
      path: '/tm/order/receipt/getLog'
    },
    {
      name: 'getBillStatusNumV5',
      desc: '状态页签数量',
      method: 'GET',
      path: '/tm/order/receipt/getBillStatusNum'
    },
    {
      name: 'cancelReceiptedV5',
      desc: '已完成送货单-取消',
      method: 'GET',
      path: '/tm/order/receipt/cancelReceipted'
    },
    {
      name: 'backListV5',
      desc: '已完成送货单-列表',
      method: 'GET',
      path: '/tm/order/receipt/backList'
    },
    {
      name: 'batchReviewV5',
      desc: '批量审核',
      method: 'POST',
      path: '/tm/order/receipt/thd/receipt/batch'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/order/receipt.js